import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    createGroupResponse: null,
    inviteFriendResponse: null,
    groupDetails: null,
    usersList: null
  },
  getters: {
    CREATE_GROUP_RESPONSE: state => state.createGroupResponse,
    INVITE_FRIEND_RESPONSE: state => state.inviteFriendResponse,
    GROUP_DETAILS: state => state.groupDetails,
    USERS_LIST: state => state.usersList
  },
  mutations: {
    SET_CREATE_GROUP_RESPONSE: (state, payload) => {
      state.createGroupResponse = payload
    },
    SET_INVITE_FRIEND_RESPONSE: (state, payload) => {
      state.inviteFriendResponse = payload
    },
    SET_GROUP_DETAILS: (state, payload) => {
      state.groupDetails = payload
    },
    SET_USERS_LIST: (state, payload) => {
      state.usersList = payload
    }
  },
  actions: {
    CREATE_GROUP: async (context, payload) => {
      try {
        const response = await Axios.post('/group', payload)
        context.commit('SET_CREATE_GROUP_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_CREATE_GROUP_RESPONSE', error.response.data)
      }
    },

    INVITE_FRIEND: async (context, payload) => {
      try {
        const response = await Axios.post('/group/invite', payload)
        context.commit('SET_INVITE_FRIEND_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_INVITE_FRIEND_RESPONSE', error.response.data)
      }
    },
    FETCH_GROUP_DETAILS: async (context, payload) => {
      try {
        const response = await Axios.post('/group/details', payload)
        context.commit('SET_GROUP_DETAILS', response.data)
      } catch (error) {
        context.commit('SET_GROUP_DETAILS', error.response.data)
      }
    },
    FETCH_USERS: async context => {
      try {
        const response = await Axios.get('/user/all?exceptMe=true')
        context.commit('SET_USERS_LIST', response.data)
      } catch (error) {
        context.commit('SET_USERS_LIST', error.response.data)
      }
    }
  }
}
